import React from 'react';
import PropTypes from 'prop-types';

const CheckboxComponent = (props) => {
  const {
    id, checked, onChange, name, link,
  } = props;

  return (
    <div>
      <input id={id} name={name} type="checkbox" checked={checked} onChange={onChange} />
      <label htmlFor={name}>
        <a href={link}>{name}</a>
      </label>
    </div>
  );
};

CheckboxComponent.propTypes = {
  name: PropTypes.string.isRequired,
  checked: PropTypes.bool,
  onChange: PropTypes.func.isRequired,
  link: PropTypes.string,
  id: PropTypes.number,
};

CheckboxComponent.defaultProps = {
  link: '',
  id: 0,
  checked: true,
};

export default CheckboxComponent;
